import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {TranslateService} from '@ngx-translate/core';
import {ItemJson, SelfScanService, SelfScanServiceDetail, SelfScanServiceTrx} from '../../../models/loyalty-selfScan-service.model';
import {LoyaltySelfscanserviceService} from '../../../services/loyalty/loyalty-selfscanservice.service';
import {LoyaltySelfscanservicedetailService} from '../../../services/loyalty/loyalty-selfscanservicedetail.service';
import * as moment from 'moment';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {CalendarTranslateService} from '../../../modules/UIKit/services/calendarTranslate.service';
import {StoreModel} from '../../../models/store-common.model';
import {StoreCommonService} from '../../../services/store/store-common.service';
import {SelfScanConfDetail} from '../../../models/loyalty-selfScan.model';
import {isUndefined} from 'util';

@Component({
  selector: 'app-loyalty-self-scan-service-trx',
  templateUrl: './loyalty-self-scan-service-trx.component.html',
  styleUrls: ['./loyalty-self-scan-service-trx.component.css']
})
export class LoyaltySelfScanServiceTrxComponent implements OnInit {

  @Input() selfscantrxId: number;
  fields: any;
  form: FormGroup;
  showDetail = false;
  selfdetailsForm: Array<FormGroup>;

  constructor(
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    public selfscanService: LoyaltySelfscanservicedetailService,
    private fb: FormBuilder,
    private calendarTranslate: CalendarTranslateService,
    public selfscanServiceDetail: LoyaltySelfscanservicedetailService,
  ) { }

  get details(): FormArray {
    return this.form.get('details') as FormArray;
  }

  ngOnInit() {

    this.selfscantrxId = this.activatedRoute.snapshot.params['selfscantrxId'];
    this.selfdetailsForm = [];
    let translate: Observable<any>;
    let selfscanSrvTrx: Observable<SelfScanServiceTrx>;
    let selfdetailsForm: Observable<ItemJson>;
    let serfscanRecord: Observable<SelfScanServiceDetail>;

    translate = this.translate.get([
      'self_scan_trx.header',
      'self_scan_trx.title',
      'self_scan_trx.store',
      'self_scan_trx.trxNum',
      'self_scan_trx.startTime',
      'self_scan_trx.endTime',
      'self_scan_trx.totalAmountCassa',
      'self_scan_trx.totalAmountApp',
      'self_scan_trx.barcode',
      'self_scan_trx.regularPrice_cassa',
      'self_scan_trx.regularPrice_app',
      'self_scan_trx.itemId',
      'self_scan_trx.action',
      'self_scan_trx.article_descr',
      'self_scan_trx.termCode',
      'self_scan_trx.itemsNumberApp',
      'self_scan_trx.itemsNumberCassa',
      'self_scan_trx.itemsTitle',
      'self_scan_trx.action',
      'self_scan_trx.quantity_cassa',
      'self_scan_trx.quantity_app',
      'self_scan_service.customer_id',
      'self_scan_service_detail.card_id',
      'self_scan_service_detail.division_id',
      'self_scan_service_detail.store_id',
      'common.reason'
    ])

    selfscanSrvTrx = this.selfscanService.getJson(this.selfscantrxId);
    selfdetailsForm = Observable.of(new ItemJson());
    serfscanRecord = this.selfscanServiceDetail.getOneDetail(this.selfscantrxId);

    Observable.zip(translate, selfscanSrvTrx, selfdetailsForm, serfscanRecord).subscribe(([resTranslate, resSelfScanItm, resDetail, resSelfScanRecord]) => {

      if ( !isUndefined(resSelfScanItm.items) ) {
        for (const service of resSelfScanItm.items) {
          this.selfdetailsForm.push(this.fb.group(this.getSelfDetail(service)));
        }
      }

      this.fields = {
        totalAmountCassa: resTranslate['self_scan_trx.totalAmountCassa'],
        totalAmountApp: resTranslate['self_scan_trx.totalAmountApp'],
        itemsNumberApp: resTranslate['self_scan_trx.itemsNumberApp'],
        itemsNumberCassa: resTranslate['self_scan_trx.itemsNumberCassa'],
        startTime: resTranslate['self_scan_trx.startTime'],
        endTime: resTranslate['self_scan_trx.endTime'],
        trxNum: resTranslate['self_scan_trx.trxNum'],
        storeCode: resTranslate['self_scan_trx.store'],
        barcode: resTranslate['self_scan_trx.barcode'],
        itemId: resTranslate['self_scan_trx.itemId'],
        header: resTranslate['self_scan_trx.header'],
        title: resTranslate['self_scan_trx.title'],
        termCode: resTranslate['self_scan_trx.termCode'],
        itemsTitle: resTranslate['self_scan_trx.itemsTitle'],
        action: resTranslate['self_scan_trx.action'],
        quantity_cassa: resTranslate['self_scan_trx.quantity_cassa'],
        quantity_app: resTranslate['self_scan_trx.quantity_app'],
        regularPrice_cassa: resTranslate['self_scan_trx.regularPrice_cassa'],
        regularPrice_app: resTranslate['self_scan_trx.regularPrice_app'],
        customer_id: resTranslate['self_scan_service.customer_id'],
        card_id: resTranslate['self_scan_service_detail.card_id'],
        division_id: resTranslate['self_scan_service_detail.division_id'],
        store_id: resTranslate['self_scan_service_detail.store_id'],
        reason_description: resTranslate['common.reason']
      };


      this.form = this.fb.group({
        totalAmountApp: [resSelfScanItm.header.app ? resSelfScanItm.header.app.totalAmount : ''],
        totalAmountCassa: [resSelfScanItm.header.cassa ? resSelfScanItm.header.cassa.totalAmount : ''],
        itemsNumberApp: [resSelfScanItm.header.app ? resSelfScanItm.header.app.itemsNumber : ''],
        itemsNumberCassa: [resSelfScanItm.header.cassa ? resSelfScanItm.header.cassa.itemsNumber : ''],
        startTimeCassa: [(resSelfScanItm && resSelfScanItm.header.cassa && resSelfScanItm.header.cassa.startTime) ? moment(resSelfScanItm.header.cassa.startTime).format(this.calendarTranslate.pcalendarTranslate.dateFormatHour.toUpperCase()).toString() : ''],
        endTimeCassa: [(resSelfScanItm && resSelfScanItm.header.cassa && resSelfScanItm.header.cassa.endTime) ? moment(resSelfScanItm.header.cassa.endTime).format(this.calendarTranslate.pcalendarTranslate.dateFormatHour.toUpperCase()).toString() : ''],
        trxNumCassa: [resSelfScanItm.header.cassa ? resSelfScanItm.header.cassa.trxNum : ''],
        storeCodeCassa: [resSelfScanItm.header.cassa ? resSelfScanItm.header.cassa.storeCode : ''],
        selfscantrxId: [this.selfscantrxId],
        termCodeCassa: [resSelfScanItm.header.cassa ? resSelfScanItm.header.cassa.termCode : ''],
        customer_description: [resSelfScanRecord[0].customer_description || ''],
        card_id: [resSelfScanRecord[0].card_id || ''],
        self_scanning_service_id: [resSelfScanRecord[0].self_scanning_service_id || ''],
        division_id: [resSelfScanRecord[0].division_name || ''],
        store_id: [resSelfScanItm.header.cassa ? resSelfScanItm.header.cassa.storeCode + ' - ' + resSelfScanRecord[0].store_name : ''],
        reason_description: [resSelfScanRecord[0].reason_description || ''],
        details: this.fb.array(this.selfdetailsForm)

      });

    });

  }

  openDetail() {
    this.showDetail = true;
  }

  getSelfDetail(selfdetail: ItemJson) {
    return {
      barcode: [selfdetail.barcode || null],
      itemId: [selfdetail.itemId || ''],
      quantity_app: [selfdetail.quantity_app || ''],
      quantity_cassa: [selfdetail.quantity_cassa || ''],
      regularPrice_app: [selfdetail.regularPrice_app || ''],
      regularPrice_cassa: [selfdetail.regularPrice_cassa || ''],
      action: [selfdetail.action || ''],
      check_quantity: [ selfdetail.quantity_app ===  selfdetail.quantity_cassa || selfdetail.action !== 'self' ? 0 : 1],
      check_price: [ selfdetail.regularPrice_app ===  selfdetail.regularPrice_cassa || selfdetail.action !== 'self' ? 0 : 1]
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-self-scan-service-trx/loyalty-self-scan-service-trx.component.ts